import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { IconBox } from '../IconBox/index.js';

/**
 * @deprecated Comes standard with Tag.
 */
var TagIcon = forwardRef(function TagIcon(_a, ref) {
    var children = _a.children, look = _a.look, props = __rest(_a, ["children", "look"]);
    return (jsx(IconBox, __assign({ ref: ref, themeKey: "tagIcons", className: "TagIcon look-".concat(look), look: look }, props, { children: children })));
});

export { TagIcon };
//# sourceMappingURL=TagIcon.js.map
